import { memo } from 'react';
import PropTypes from 'prop-types';

const BzTab = ({ draggedIndex = null, isDraggble = false, handleDragStart, handleDragOver, handleDrop, className = '', index, isActive = false, children, tabKey, tabindex = 0, id, ...props }) => {
    return (
        <div
            style={{
                backgroundColor: draggedIndex === index ? 'green' : ''
            }}
            key={index}
            onDragStart={(e) => handleDragStart(e, index, children)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDrop={(e) => handleDrop(e, index)}

            draggable={isDraggble}
            className={`${isActive ? 'active' : ''} ${className} d-inline-block`} data-bs-toggle="tab" data-bs-target={`#${tabKey}`} tabindex={tabindex} id={id} role="tab" type="button" {...props}>
            {children}
        </div>
    );
};


BzTab.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    tabKey: PropTypes.string.isRequired,
};


export default memo(BzTab);
